export const SUPP_INFO_FORM = "step5Form";

export const PAYMENT_UPFRONT_OPTIONS = [
  {
    value: "0.50",
    children: "50%",
  },
  {
    value: "1",
    children: "100%",
  },
];

export const ADD_DESIGNS_OPTIONS = ["0", "1", "2", "3", "4"].map(value => ({
  value,
  children: value,
}));



// WEBPACK FOOTER //
// ./src/routes/Step5/constants.ts